import GenericView from 'js/views/generic.view';
import CampaignConfiguration from 'js/models/campaign.config.model';
import Template from 'js/templates/message.template.htm';
import SmsView from 'js/views/message.sms.view';
import MailView from 'js/views/message.mail.view';
import MessageReportView from 'js/views/message.report.view';
import {delegateEvent} from "../utils/event.delegator";
import {el, model, tagName, template} from "../adapters/backbone-decorators";

@el("#edit-message")
@tagName('div')
@template(Template)
@model(CampaignConfiguration, {contactIds: [], includedGroups: [], message: ""})
class MessageView extends GenericView {

    constructor(options) {
        super(options)
    }

    render() {
        super.render();
        const model = this.model;
        const sendingMessages = model.get("campaignId") > 0 &&
            model.get("campaignStatus") === "NOT_STARTED" &&
            model.get("startDate") < Date.now();
        if ((model.get("campaignId") > 0 && model.get("campaignStatus") !== "NOT_STARTED") || sendingMessages) {
            this.childView = new MessageReportView({
                model,
                awaitsForMessagesToBeSent: sendingMessages
            });
        } else if (model.get("campaignChannel") === 'SMS') {
            this.childView = new SmsView({model});
        } else {
            this.childView = new MailView({model});
        }
        delegateEvent(this, this.childView, "changed:campaignStatus");
        delegateEvent(this, this.childView, "spamResult");
    }

    load(id) {
        this.model.set("id", id);
        this.model.fetch().done(() => this.render());
    }
}

export default MessageView;
